<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2">
          <h6 class="modal-title">{{$t('Dashboard Widgets')}}</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close()">
            <span aria-hidden="true">
              <cancel-icon class="close-icon" style="height: 30px !important;
                width: 30px !important;
                color: #fff;">
              </cancel-icon>
            </span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="w-100 widgets-sub-body">
            <div v-for="widget in dashboardWidgetStoreArray" :key="widget.name" class="widget-wrapper">
                <div style="width:77%">
                  <div class="widget-name">{{widget.name}}</div>
                  <div class="widget-description">{{widget.description}}</div>
                </div>
                <div class="primary-btn-style justify-content-end" style="width:23%">
                    <button class="btn btn-outline-secondary m-1" v-on:click="addSelectedWidgetToDashboard(widget)">{{$t('Add')}}</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import Utils from "../../components.utils.js";

export default ({
    data(){
        return{
            dashboardWidgetStoreArray:[],
            widgetsArrayToRegister:[],
            isNewWidgetAdded:false
        }
    },
    components:{
        'cancel-icon':cancelIcon,
    },
    computed:{
        ...mapGetters("registry",["getRegisteredDashboardWidgets"]),
    },
    methods:{
        getBinsStorageWidgetComponentName(){
            return 'bins-storage'
        },
        close(){
            this.$emit('close')
        }, 
        addSelectedWidgetToDashboard(item){
            let payload = {"name":item.name};
            this.addToDashboard(payload).then((data) => {
              if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.isNewWidgetAdded = true;
                    this.$emit('addWidgetToDashboard',data)
                    if(data.message){
                      this.$toast.success(data.message);
                    }else{
                      this.$toast.success("Added");
                    }
                } else {
                    if(data.message){
                      this.$toast.error(data.message);
                    }else{
                      this.$toast.error("Failed");
                    }
                }
            })
        },
        ...mapActions("dashboard", ["getAllWidgetsFromServer","addToDashboard"]),
        ...mapMutations("registry",["registerDashboardWidgets","unsetDashboardWidgets"]),
    },
    created(){
        this.getAllWidgetsFromServer().then((data) => {
          this.dashboardWidgetStoreArray = data["dashboard_widgets"];
        });
    }
})
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 900px;
    width: 800px;
    height: 500px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
     background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 500px;
      user-select: text !important; 
      cursor:text;
      overflow:auto;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 8%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.nav-item{
    color: $dull-text-color !important;
}

.active{
    background: $primary-background !important;
    color: $text-color !important;
}
.top-nav-bar{
    text-align: center;
    background: $primary-background;
}

.widgets-sub-body{
  display: flex;
  justify-content: start;
  flex-flow: wrap;
  .widget-wrapper{
    width: 50%;
    min-height: 70px;
    max-height: fit-content;
    padding: 18px;
    display:flex;
    .widget-description{
      color: $secondary-text-color;
    }
  }
}

 /* width */
  ::-webkit-scrollbar {
      width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
  }

  .primary-btn-style{
      display: flex;
      align-items: self-start;
      justify-content: center !important;
    button{
      height: 38px;
      width: 70px;
      font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

</style>
